import { type FetchLedgerSummaryByLedgerIdParams } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { type WalletLedgerSummaryInfo } from '../../models';
import { fetchLedgerSummaryByLedgerId } from '../api';

/**
 * TODO Remove once generated types are fixed
 */

export const LedgerSummaryQueryKey = 'ledgerSummary';

/**
 *
 * @param FetchLedgerSummaryByLedgerIdParams
 * @returns LedgerSummary
 */
export const useLedgerSummaryByIdQuery = <TData = undefined | WalletLedgerSummaryInfo>(
	ledgerId: string,
	select?: (data: undefined | WalletLedgerSummaryInfo) => TData,
	params?: FetchLedgerSummaryByLedgerIdParams
) =>
	useQuery({
		enabled: !!ledgerId,
		queryFn: () =>
			fetchLedgerSummaryByLedgerId({
				'details[]': ['currency', 'nonTradableDetails', 'inUseDetails', 'stakeAndScoreDetails'],
				ledgerId: ledgerId,
				...params
			}),
		queryKey: [LedgerSummaryQueryKey, ledgerId, params],
		select: select as (data: unknown | WalletLedgerSummaryInfo) => TData
	});
